import { ReactComponent as IconLightning } from './icon_lightning.svg';
import { ReactComponent as IconBook } from './icon_book.svg';
import { ReactComponent as IconStar } from './icon_star.svg';
import { ReactComponent as IconBlueSquare } from './icon_blue_square.svg';
import { ReactComponent as IconBlackDiamond } from './icon_black_diamond.svg';

export const inlineSvgMapping = {
  icon_lightning: IconLightning,
  icon_book: IconBook,
  icon_star: IconStar,
  icon_blue_square: IconBlueSquare,
  icon_black_diamond: IconBlackDiamond,
};

export type TeachingLearningSequenceSvgIds = keyof typeof inlineSvgMapping;

type Props = {
  id: TeachingLearningSequenceSvgIds;
  width?: string | number;
  height?: string | number;
  className?: string;
};

const TeachingLearningSequenceInlineSvg = (props: Props) => {
  const Svg = inlineSvgMapping[props.id];
  return (
    <Svg
      focusable="false"
      width={props.width || 16}
      height={props.height || 16}
      {...props}
    />
  );
};

export default TeachingLearningSequenceInlineSvg;
